import React, { FunctionComponent } from 'react'
import { Heading, Text, Icon, useIsBreakpointSmall, Panel } from '@afterpaytouch/core'
import styles from './style.module.scss'
import { useTranslation } from 'next-i18next'
import { useConsumerSizes } from '../../utils/responsive'
import clsx from 'clsx'

const I18N_NAMESPACE = ['common', 'orders']

export const NoUpcomingPayment: FunctionComponent<{}> = () => {
  const { t } = useTranslation(I18N_NAMESPACE)
  const isBpSmall = useIsBreakpointSmall()
  const classNames = clsx(isBpSmall && styles.isBpSmall)

  const { headingSize, textSize, iconSize, subheadingSize } = useConsumerSizes()

  return (
    <div className={classNames}>
      <Panel>
        <Panel.Head>
          <div className={styles.header}>
            <div className={styles.icon}>
              <Icon.Check size={iconSize} title={'check icon'} />
            </div>
            <Heading size={headingSize} testNameSpace='upcoming-payment'>
              {t('upcomingPayments:noUpcomingPayments:header')}
            </Heading>
          </div>
        </Panel.Head>
        <Panel.Content bordered={true}>
          <div className='py-3 md:py-2'>
            <Text size={textSize}>{t('upcomingPayments:noUpcomingPayments:contentSubheader')}</Text>
          </div>
        </Panel.Content>
      </Panel>
    </div>
  )
}
